export default {
    mapLandmarkVisibleLandmarkGroups_success: "Preferencias guardadas exitosamente",
    mapLandmarkVisibleLandmarkGroups_selectAll: "Seleccionar todo",
    mapLandmarkVisibleLandmarkGroups_unselectAll: "Des-seleccionar todo",
};